module.exports = __webpack_public_path__ + "assets/valance-classic-scallop-short-selected.38432da1.svg";